//
//
//
//
//
//
//
//

import '../../plugins/dropload/dropload.css'
import '../../plugins/dropload/dropload.js'

export default {
    props: {
        successCount: {
            type: Number,
            default: 0
        },
        end: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            me: null,
            //断点
            breakpoint: false,

            //参数
            para: {
                successCount: 0,
                end: false,
                error: false
            },
            hide: false,

            //滚动实例
            dropload: null
        }
    },
    //计算属性
    computed: {

    },
    watch:{
        'successCount'(){
            //console.log('监听下')
            this.breakpoint = false;
            this.$nextTick(() => {
                //console.log(this.me, this.end, this.error)
                //存在滚动
                if(this.me){
                    //如果主动结束或者错误
                    if(this.end || this.error){
                        //没有数据-重置-锁定滚动
                        this.me.noData(true);
                        this.me.resetload();
                        this.me.lock('down');
                        return;
                    }else{
                        this.me.noData(false);
                        this.me.unlock('down');
                    }
                    // 每次数据加载完，必须重置
                    this.me.resetload();
                }
            })
        }
    },
    beforeDestroy() {
        $(window).off();
    },
    mounted() {
        this.handleDropload();
    },
    methods: {
        onScrollload(){
            if(this.error){
                this.me.noData(false);
                this.me.unlock('down');
                this.me.resetload();
                this.$emit('onScrollReload', this.end, this.error);
            }
        },
        //滚动加载
        handleDropload(){
            this.hide = false;
            let _this = this;
            _this.me = null;
            this.$nextTick(() => {
                //存在实例
                if(this.dropload){
                    this.dropload.noData && this.dropload.noData(false);
                    $('.dropload-down').remove();
                    this.dropload = null;
                }
                this.dropload = $('.scrollload').dropload({
                    scrollArea : window,
                    loadDownFn : function(me){
                        //console.log('进来');
                        if(!_this.me){
                            _this.me = me;
                            _this.breakpoint = false;
                        }
                        //断点
                        if(!_this.breakpoint) {
                            _this.breakpoint = true;
                            _this.$emit('onScrollBottom');
                        }

                    }
                });
            })
        },
        reset(){
            this.handleDropload();
        },
        hidden(){
            if(this.me){
                //没有数据-重置-锁定滚动
                this.me.noData(true);
                this.me.resetload();
                this.me.lock('down');
            }
            this.hide = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/scrollload/scrollload.vue